import React from "react";
import Skeleton from "@material-ui/lab/Skeleton";

export default function SelectToggleMenuSkeleton() {
  return (
    <Skeleton className="select-toggle-menu" animation="wave" height={40} />
  );
}
